import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.LineItemView.';
  public static readonly emptyTitle = `${Id.prefix}emptyTitle`;
}

export class LangLineItemView {
  private constructor() {}
  public static emptyTitle(params: { title: string }): string {
    return interpolate(Id.emptyTitle, params);
  }
}

export class LineItemViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.emptyTitle,
      '{{title}} cannot have an empty Title',
      'Validation message for empty title in line item dialog'
    );
  }
}
